<template>
  <el-dialog title="Thông báo" :visible.sync="localVisible" width="560px" :append-to-body="false">
    <div style="word-break: keep-all;">
      Bài chấm đầu tiên của giảng viên có dấu hiệu chưa đạt yêu cầu.<br />
      Để xác định đây là lỗi sự vụ hay lỗi hệ thống, bạn cần tiếp tục thanh tra thêm một số bài tương tự trong lớp.
    </div>
    <span slot="footer" class="dialog-footer">
      <button class="btn btn-light-gray font-weight-bold mr-2" @click="onCancel">
        <i class="fas fa-times"></i> Hủy
      </button>
      <button class="btn btn-purple font-weight-bold mr-2" @click="$emit('confirm')">
        <i v-if="loading" class="fas fa-spinner fa-spin"></i>
        <i v-else class="fas fa-arrow-right"></i>
        {{ loading ? 'Đang tải...' : 'Tiếp tục' }}
      </button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'SaveNeedMoreDialog',
  props: {
    visible: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  computed: {
    localVisible: {
      get() { return this.visible; },
      set(v) { this.$emit('update:visible', v); }
    }
  },
  methods: {
    onCancel() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
    }
  }
}
</script>

<style scoped>
</style>


